import { render, staticRenderFns } from "./DetailExampleList.vue?vue&type=template&id=36cd3a90&scoped=true&"
import script from "./DetailExampleList.vue?vue&type=script&lang=js&"
export * from "./DetailExampleList.vue?vue&type=script&lang=js&"
import style0 from "./DetailExampleList.vue?vue&type=style&index=0&id=36cd3a90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd3a90",
  null
  
)

export default component.exports